<template>
<tr>
    <td>
        <a href="#" class="text-black font-sans-bold" @click.stop.prevent="editCategory">{{category.title}}</a>
    </td>
    <td>{{category.slug}}</td>
    <td>
        <span v-if="category.category_group">{{ category.category_group.title }}</span>
    </td>
</tr>
</template>

<script>
    export default {
        name: 'CategoryItem',
        props: {
            category: Object
        },
        computed: {},
        methods: {
            editCategory() {
                this.$store.dispatch('setActiveCategory', this.category)
                this.$router.push({ name: 'category-edit', params: { id: this.category.id }})
            }
        },
        mounted() {}
    }
</script>
